module.exports = __webpack_public_path__ + "img/empty.5eeebd47.png";